// extracted by mini-css-extract-plugin
export var explainable = "_ig-a";
export var printerCard = "_ig-1";
export var printerCardConfigured = "_ig-2";
export var printerCardError = "_ig-3";
export var printerCardsContainer = "_ig-0";
export var printerIcon = "_ig-8";
export var printerIconConfigured = "_ig-5";
export var printerIconContainer = "_ig-4";
export var printerIconError = "_ig-6";
export var printerIconUnconfigured = "_ig-7";
export var workstationsTableCard = "_ig-9";